import { render, staticRenderFns } from "./LandingPageAPI.vue?vue&type=template&id=65386dd8"
import script from "./LandingPageAPI.vue?vue&type=script&lang=ts"
export * from "./LandingPageAPI.vue?vue&type=script&lang=ts"
import style0 from "./LandingPageAPI.vue?vue&type=style&index=0&id=65386dd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports